const Svgs = [
    'rewards',
    '360-degree',
    'Expert-tech',
    'inStock-ship',
    'filter-sort',
    'add-to-list',
    'wheel',
    'facebook',
    'twitter',
    'pinterest',
    'instagram',
    'youtube',
    'play',
    'phone',
    'phone_unavailable',
    'star',
    'star-half',
    'fast_mail',
    'magnifyingglass',
    'menu',
    'garage',
    'parts',
    'toolbox',
    'SpeedwayMotors_Logo',
    'street',
    'race',
    'trash',
    'backarrow',
    'right-arrow',
    'catalog',
    'close',
    'chevron',
    'chevron-up',
    'chevron-down',
    'cloud_upload',
    'buildlist',
    'cart',
    'user',
    'deals',
    'trackorder',
    'info',
    'minus',
    'plus',
    'share',
    'standard_delivery',
    'truck_shipment',
    'unavailable',
    'universal_fit',
    'warning',
    'box',
    'check',
    'external_link',
    'fast_and_free',
    'fast_shipping',
    'factory_shipped',
    'made_to_order',
    'in_store_pickup',
    'add',
    'backordered',
    'kit',
    'Wrench',
    'dollar',
    'help',
    'add_to_cart',
    'CARB',
    'prop65',
    'timer',
    'lock',
    'copy',
    'edit',
    'SpeedwayMotors_Wheel_Full_Color',
    'SpeedwayMotors_Logo_Full_Color',
    'creditcard',
    'moreInformation',
    'chevron-left',
    'list-view',
    'grid-view',
    'thumb_down',
    'thumb_up',
    'wheel_hollow',
    'video',
    'tiktok',
    'heart',
    'engine',
    'pistons',
    'heart-selected',
    'rearaxle',
    'transmission',
    'icon_cloud_download'
]
Svgs.sort()

const SvgResourceURL = '/Svgs/sprite-oct-6-2023.svg'

export { SvgResourceURL }

export default Svgs

